<template>
    <v-content>
        <v-layout column align-center>
            <v-btn large depressed fab class="btn-fab" @click="$refs.fileInput.click()" :loading="isLoader" :disabled="isDisabled">
                <v-icon dark class="grey--text text--darken-1" x-large>{{ icon }}</v-icon>
            </v-btn>
            <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="upImg">
            <p>{{ title }}</p>
        </v-layout>
    </v-content>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/storage';

export default {
  data() {
    return {
      icon: 'camera_alt',
      isDisabled: false,
      isLoader: false,
      urlImg: '',
    };
  },
  props: {
    title: String,
    email: String,
    folder: String,
    name_img: String,
  },
  methods: {
    async upImg(event) {
      this.isLoader = true;

      const { files } = event.target; // pegando o objeto do arquivo
      const image = files[0]; // pegando o objeto img

      // referencia da imagem para upload
      const fileData = firebase.storage().ref(`/${this.folder}/${this.email}/${this.name_img}`);

      // enviando a img usando a referencia gerada acima para o firebase
      fileData.put(image).then(
        (res) => {
          // referencia da imagem para download
          const pathReference = firebase.storage().ref(`/${this.folder}/${this.email}/${this.name_img}`);
          // pegando a url da imagem através da referencia gerada acima
          pathReference.getDownloadURL().then((url) => {
            this.isDisabled = true;
            this.icon = 'check';
            this.emitUrl(url);
          }).catch((error) => {
            console.log(error);
          });
        },
      ).catch((err) => {
        console.log(err);
      })
        .finally(() => this.isLoader = false);
    },
    emitUrl(v) {
      this.$emit('url-img', v);
    },
  },
};
</script>

<style scoped>
    .btn-fab{
        border-radius: 50%;
    }
</style>
